import React from "react"
import MailChimpForm from "./MailChimpForm"
import { useStaticQuery, graphql } from "gatsby"

const NewsLetter = () => {
  const data = useStaticQuery(graphql`
    query {
      wpContentSettings(id: { eq: "cG9zdDoyMQ==" }) {
        home {
          mailTopTitle
          mailTitle
          mailSubmitText
        }
      }
    }
  `)

  const { mailTopTitle, mailTitle, mailSubmitText } =
    data.wpContentSettings.home

  return (
    <>
      <div className="row text-center">
        <div className="col-lg-10 col-xl-10 col-xxl-8 mx-auto my-6">
          <h2 className="fs-17 text-uppercase text-muted mb-3">
            {mailTopTitle}
          </h2>
          <h3 class="display-5 mb-3">{mailTitle}</h3>
        </div>
      </div>
      <div className="row gx-0">
        <div className="col-lg-8 mx-auto">
          <MailChimpForm submitText={mailSubmitText} />
        </div>
      </div>
    </>
  )
}

export default NewsLetter
